import { useCallback } from 'react'

import { spaceClient } from 'lib/axios'
import { useSelector } from 'react-redux'
import { getUser } from 'state/ducks/user/selectors'
import { StoreState } from 'state/ducks'

type LogParams = {
  timestamp: string
  screen: string
  env: string
  platform: string
  action_type: string
  api_sku: string
  latitude: number
  longitude: number
  user_input_text: string
}

export const useGoogleMapLogger = () => {
  const user = useSelector((state: StoreState) => getUser(state))

  const requestLog = useCallback(
    async (params: LogParams) => {
      try {
        const response: any = await spaceClient.post('/api/app/v1/google_map_logs', {
          ...params,
          user_id: user?.user_id,
        })

        return {
          isOk: true,
          data: response.data,
        }
      } catch (error: any) {
        return {
          isOk: false,
          error: error?.response?.data,
        }
      }
    },
    [user?.user_id]
  )

  return {
    logGoogleMapUsage: requestLog,
  }
}
